import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface HSQBeamIconProps {
    size?: number;
    color?: string;
}

const HSQBeamIcon: React.FC<HSQBeamIconProps> = (props) => (
    <SvgIcon {...props} className="sx-icon-hsqbeam">
        {
            <path d="M18.158 19.052v-15.128h-12.405v15.128h-4.604v1.148h21.704v-1.148h-4.694zM17.696 19.052h-11.482v-13.98h11.482v13.981z"></path>

        }  </SvgIcon>
);

export default HSQBeamIcon;
